import { render, staticRenderFns } from "./display-field-select.vue?vue&type=template&id=1ba301a0&scoped=true&"
import script from "./display-field-select.vue?vue&type=script&lang=ts&"
export * from "./display-field-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba301a0",
  null
  
)

export default component.exports